export enum QuizURL {
  Quiz15 = 'quiz15',
  Quiz15Winter = 'quiz15-winter',
  QuizADHD = 'quiz-adhd',
  QuizSummerCamp = 'quiz-summer-camp',
  AfterschoolQuiz = 'afterschool-quiz',
  PersonalizedQuiz = 'personalized-quiz',
  PersonalizedSchoolStressQuiz = 'personalized-school-stress-quiz',
  PersonalizedContentQuiz = 'personalized-content-quiz',
  PersonalizedSummerQuiz = 'personalized-summer-quiz',
  PersonalizedWinterQuiz = 'personalized-winter-quiz',
  RegistrationQuiz = 'registration-quiz',
  ReadingQuiz = 'reading-quiz',
}
